import React from "react"
import Ext_Control from "./Ext_Control"
class Ext_Date extends Ext_Control {
  getIsShowTime = () => {
    const controlOpts = this.getControlOpts()
    if (controlOpts.showTime === true) {
      return true
    }
    return false
  }
  getFormatDate = () => {
    return this.getFormat()
  }
  render() {
    return <div></div>
  }
}

export default Ext_Date
